// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingTemplatesWrapper__MoWDq {
  position: relative;
}

.costSavingTemplatesHeader__X4sks {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.costSavingTemplatesTitle__Hl6mV {
  font-size: 11px;
  font-weight: 400;
  color: var(--title-inputs-sections-title);
  line-height: 14px;
  text-transform: uppercase;
  margin: unset;
}

.costSavingTemplatesTable__S5h47 {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  display: grid;
  box-shadow: var(--basic-box-shadow);
  background: var(--tables-primary-row-surface-default);
}
.costSavingTemplatesTable__S5h47 thead {
  display: grid;
  position: relative;
}
.costSavingTemplatesTable__S5h47 tr {
  box-shadow: none;
  color: inherit;
  display: table-row;
  vertical-align: middle;
  outline: 0;
  display: flex;
}
.costSavingTemplatesTable__S5h47 td {
  padding: 16px 25px;
  color: var(--tables-primary-row-text-main);
  font-weight: 400;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
  font-size: 14px;
  text-align: left;
  display: flex;
  width: 100%;
  align-items: center;
}
.costSavingTemplatesTable__S5h47 th {
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  text-align: left;
  display: flex;
  width: 100%;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.costSavingTemplatesBodyRow__olomQ:hover {
  background: var(--tables-primary-row-surface-hover);
}

td.actionsColumn__CRhHX,
th.actionsColumn__CRhHX {
  display: flex;
  width: 50px;
  justify-content: flex-end;
}

.actionsIconContainer__XvNiH {
  display: flex;
  width: 25px;
  height: 25px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  outline: none;
  align-items: center;
  justify-content: center;
}

.skeletonText__x4LjH {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/MultiplicationFactors/components/CostSavingTemplates/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,mCAAA;EACA,qDAAA;AAzEF;AA2EE;EACE,aAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AA1EJ;AA6EE;EACE,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,yDAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mDAAA;EACA,uCAAA;AA5EJ;;AAiFE;EACE,mDAAA;AA9EJ;;AAkFA;;EAEE,aAAA;EACA,WAAA;EACA,yBAAA;AA/EF;;AAkFA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/EF;;AAkFA;EACE,YAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingTemplatesWrapper {\n  position: relative;\n}\n\n.costSavingTemplatesHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.costSavingTemplatesTitle {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--title-inputs-sections-title);\n  line-height: 14px;\n  text-transform: uppercase;\n  margin: unset;\n}\n\n.costSavingTemplatesTable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  display: grid;\n  box-shadow: var(--basic-box-shadow);\n  background: var(--tables-primary-row-surface-default);\n\n  thead {\n    display: grid;\n    position: relative;\n  }\n\n  tr {\n    box-shadow: none;\n    color: inherit;\n    display: table-row;\n    vertical-align: middle;\n    outline: 0;\n    display: flex;\n  }\n\n  td {\n    padding: 16px 25px;\n    color: var(--tables-primary-row-text-main);\n    font-weight: 400;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n    font-size: 14px;\n    text-align: left;\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    text-align: left;\n    display: flex;\n    width: 100%;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n  }\n}\n\n.costSavingTemplatesBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\ntd.actionsColumn,\nth.actionsColumn {\n  display: flex;\n  width: 50px;\n  justify-content: flex-end;\n}\n\n.actionsIconContainer {\n  display: flex;\n  width: 25px;\n  height: 25px;\n  user-select: none;\n  cursor: pointer;\n  outline: none;\n  align-items: center;\n  justify-content: center;\n}\n\n.skeletonText {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingTemplatesWrapper": `costSavingTemplatesWrapper__MoWDq`,
	"costSavingTemplatesHeader": `costSavingTemplatesHeader__X4sks`,
	"costSavingTemplatesTitle": `costSavingTemplatesTitle__Hl6mV`,
	"costSavingTemplatesTable": `costSavingTemplatesTable__S5h47`,
	"costSavingTemplatesBodyRow": `costSavingTemplatesBodyRow__olomQ`,
	"actionsColumn": `actionsColumn__CRhHX`,
	"actionsIconContainer": `actionsIconContainer__XvNiH`,
	"skeletonText": `skeletonText__x4LjH`
};
module.exports = ___CSS_LOADER_EXPORT___;
